module.exports = __webpack_public_path__ + "img/base_activites_rando_sportive.8ca50c42.svg";